function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import './login.scss';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { parseQueryParams, generateAuthLink } from 'shared/helper/link-helper';
import { Controls, validators } from 'shared/helper/form';
import { getRegisterFormFields } from 'shared/account/reducer';
import { getLocale } from 'researcher/application/reducer';
import { CHINA_ID } from 'researcher/domain/account/country';
import { PASSWORD_MIN_LENGTH } from 'shared/helper/form/validators';
import Link from 'shared/components/Link';
import { T, useTranslate } from 'shared/helper/translate';
import { defaultValues as institutionDefaultValues } from 'shared/account/components/InstitutionForm';
import { convertFormDataToUserUpdateRequest } from 'shared/view/user-conversion-service';
import LocalizationPreferences from '../../../shared/account/components/LocalizationPreferences';
import { registerUser, verifyUser } from '../actions';
import ProvidersV2 from './ProvidersV2';
var Form = Controls.Form,
  Text = Controls.Text,
  Password = Controls.Password,
  Checkbox = Controls.Checkbox;
var isEmail = validators.isEmail,
  notEmpty = validators.notEmpty,
  validPassword = validators.validPassword;
var defaultValues = {
  active: true,
  addedToWatchlist: false,
  agreeToTOS: false,
  companySelection: {
    value: null
  },
  country: null,
  creditNotesLocked: false,
  currency: {
    value: null
  },
  currencySelectionDisabled: false,
  email: '',
  excludeFromDelinquentCheck: false,
  firstName: '',
  foundUs: '',
  institution: institutionDefaultValues,
  language: {
    value: null
  },
  lastName: '',
  localization: '',
  optinToMarketing: false,
  orcid: '',
  otherFoundUs: '',
  overrideDownloadAvailable: false,
  password: '',
  phoneNumber: '',
  secondaryEmail: '',
  title: '',
  watchlistNotification: '',
  workplace: ''
};
function RegisterV2(_ref) {
  var _parseQueryParams$ori;
  var providers = _ref.providers,
    referringUrl = _ref.referringUrl,
    _ref$onSuccessfulRegi = _ref.onSuccessfulRegistration,
    onSuccessfulRegistration = _ref$onSuccessfulRegi === void 0 ? function () {} : _ref$onSuccessfulRegi,
    formData = _ref.formData;
  var dispatch = useDispatch();
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAll = _useState2[0],
    setShowAll = _useState2[1];
  var fields = useSelector(getRegisterFormFields);
  var processing = useSelector(function (_ref2) {
    var authentication = _ref2.authentication;
    return authentication.status.processing;
  });
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var reset = methods.reset;
  var origin = (_parseQueryParams$ori = parseQueryParams(window.location.search).origin) !== null && _parseQueryParams$ori !== void 0 ? _parseQueryParams$ori : '';
  var loginLink = generateAuthLink('login', referringUrl, origin);
  var countries = useSelector(function (_ref3) {
    var account = _ref3.account;
    return account.countries;
  });
  var currencies = useSelector(function (_ref4) {
    var account = _ref4.account;
    return account.currencies;
  });
  var currentLocalization = useSelector(function (_ref5) {
    var application = _ref5.application;
    return application.currentLocalization;
  });
  var localizations = useSelector(function (_ref6) {
    var application = _ref6.application;
    return application.localizations;
  });
  var languages = useSelector(function (_ref7) {
    var account = _ref7.account;
    return account.languages;
  });
  var _useSelector = useSelector(getLocale),
    siteLanguage = _useSelector.iso639Locale;
  var _methods$watch = methods.watch(['currencySelectionDisabled', 'country']),
    _methods$watch2 = _slicedToArray(_methods$watch, 2),
    currencySelectionDisabled = _methods$watch2[0],
    country = _methods$watch2[1];
  var filterOutCnyConditionally = function filterOutCnyConditionally(currencies) {
    return currencies.filter(function (currency) {
      if ((country === null || country === void 0 ? void 0 : country.value) !== CHINA_ID && !fields.admin) {
        if (currency.value !== 'CNY') {
          return true;
        }
      } else {
        return true;
      }
      return false;
    });
  };
  var handleRegisterUser = function handleRegisterUser(userUpdateRequest) {
    dispatch(registerUser(userUpdateRequest)).then(function (_ref8) {
      var loggedIn = _ref8.loggedIn,
        redirectUri = _ref8.redirectUri;
      if (!loggedIn) {
        return;
      }
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'signupComplete'
        });
      }
      onSuccessfulRegistration(referringUrl || redirectUri || '/');
    });
  };
  var handlePersistData = function handlePersistData(formData) {
    if (formData.email && !(formData !== null && formData !== void 0 && formData.country)) {
      dispatch(verifyUser({
        email: formData.email
      })).then(function (data) {
        return setShowAll(data);
      });
    } else {
      handleRegisterUser(convertFormDataToUserUpdateRequest(formData, {
        currencies: currencies,
        languages: languages
      }));
    }
  };
  useEffect(function () {
    if (formData) {
      reset(formData);
    }
  }, [formData, reset]);
  return /*#__PURE__*/React.createElement("div", {
    className: "new-login mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 text-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center w-75 mx-auto"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "fw-semibold"
  }, !formData ? /*#__PURE__*/React.createElement(T, {
    source: "sign-up"
  }) : /*#__PURE__*/React.createElement(T, {
    source: "Confirm your information"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-6 have-account"
  }, /*#__PURE__*/React.createElement(Link, {
    to: loginLink
  }, /*#__PURE__*/React.createElement(T, {
    source: "I have an account"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "w-75 mx-auto"
  }, formData && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(T.md, {
    source: "confirm-information-message"
  })), /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    className: "login-form clearfix",
    onSubmit: handlePersistData,
    testAttribute: "login-form"
  }, /*#__PURE__*/React.createElement(Text, {
    name: "email",
    placeholder: "work-personal-email",
    styles: {
      wrapper: 'row m-0 mb-4',
      label: 'col-4',
      controlsWrapper: 'col p-0'
    },
    messages: {
      isEmail: 'emailAddressInvalidFormat'
    },
    validators: {
      isEmail: isEmail
    },
    ariaLabel: "work-personal-email"
  }), showAll && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "password mb-4"
  }, /*#__PURE__*/React.createElement(Password, {
    placeholder: "Password",
    messages: {
      validPassword: function validPassword() {
        return /*#__PURE__*/React.createElement(T, {
          source: "password-too-short",
          params: PASSWORD_MIN_LENGTH
        });
      }
    },
    name: "password",
    validators: {
      validPassword: validPassword
    },
    styles: {
      wrapper: 'mb-4'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "row mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-50 pe-2"
  }, /*#__PURE__*/React.createElement(Text, {
    placeholder: "First name",
    styles: {
      wrapper: 'row mx-1',
      controlsWrapper: 'col p-0'
    },
    name: "firstName",
    validators: {
      notEmpty: notEmpty
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-50 ps-2"
  }, /*#__PURE__*/React.createElement(Text, {
    placeholder: "last-name",
    styles: {
      wrapper: 'row mx-1',
      controlsWrapper: 'col p-0'
    },
    name: "lastName",
    validators: {
      notEmpty: notEmpty
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(LocalizationPreferences, {
    label: "",
    allowFilterUpdates: !fields.admin,
    placeholder: "country",
    countries: countries,
    currencies: filterOutCnyConditionally(currencies),
    currencySelectionDisabled: currencySelectionDisabled,
    currentLocalization: currentLocalization,
    fields: fields.localizationPreferencesFields,
    languages: languages,
    localizations: localizations,
    methods: methods,
    siteLanguage: siteLanguage,
    styles: "border-radius"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "text-start mb-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "terms"
  }, /*#__PURE__*/React.createElement(T, {
    source: "terms-policy"
  }))), showAll && /*#__PURE__*/React.createElement("div", {
    className: "text-start terms mb-4"
  }, fields.marketingOptIn && /*#__PURE__*/React.createElement(Checkbox, {
    label: t('marketing-message'),
    name: "optinToMarketing"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("button", {
    disabled: processing,
    type: "submit",
    className: "agree-button w-100",
    "aria-label": t('agree-and-sign-up')
  }, processing ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "ms-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "agree-and-sign-up"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center my-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "divider-line w-50"
  }), /*#__PURE__*/React.createElement("span", {
    className: "mx-3 split"
  }, /*#__PURE__*/React.createElement(T, {
    source: "or"
  })), /*#__PURE__*/React.createElement("div", {
    className: "divider-line w-50"
  }))), /*#__PURE__*/React.createElement(ProvidersV2, {
    providers: providers,
    referringUrl: referringUrl
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-start"
  }, /*#__PURE__*/React.createElement("p", {
    className: "terms"
  }, /*#__PURE__*/React.createElement(T, {
    source: "privacy-policy"
  })))))));
}
export default RegisterV2;